module.exports = __webpack_public_path__ + "static/media/chevron-right-primary.9ec44c38.svg";